<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template : '#user-template',
  data     : function() {
    return {
      userFormErrors : {
        phone   : false,
        email   : false,
        address : false,
        zip     : false,
        city    : false
      },
      password : {
        current : '',
        new     : '',
        confirm : '',
        error   : false,
        updated : false
      }
    };
  },
  watch : {
    user : {
      handler(newObj, oldObj) {
        for (let key in this.userFormErrors) {
          let el = newObj[key];

          if (el === '') this.userFormErrors[key] = true;
          else if(key === 'city' && !/^([A-Za-zÄäÖöÅå]+)$/.test(el)) this.userFormErrors[key] = true;
          else this.userFormErrors[key] = false;
        }
      },
      deep : true
    },
    notifications : {
      handler(newObj, oldObj) {
        api.updateNotificationsStatus(newObj);
        this.$store.state.notifications = newObj;
      },
      deep : true
    },
    brands : {
      handler(newObj, oldObj) {
        let updateArr = newObj.reduce(function(result, brand) {
          if (brand.checked) result.push(brand.id);

          return result;
        }, []);

        api.updateUserBrands({ brands : updateArr });

        this.$store.state.brands = newObj;
      },
      deep : true
    }
  },
  computed : {
    user : function() {
      return this.$store.state.user;
    },
    notifications : function() {
      return this.$store.state.notifications;
    },
    brands : function() {
      return this.$store.state.brands;
    },
    testdrives : function() {
      let drives = this.$store.state.testdrives;

      if (drives) {
        drives = drives.map(drive => {
          if (drive.grade) {
            drive.fill = [];
            drive.fill.length = drive.grade;
            drive.empty = [];
            drive.empty.length = 5 - parseInt(drive.grade);
          }

          return drive;
        });
        drives.sort((a, b) => a.date < b.date);
      }

      return drives;
    }
  },
  methods : {
    submitUserForm : function() {
      let formValidated = true;

      for (let key in this.userFormErrors) {
        if (this.userFormErrors[key]) formValidated = false;
      }

      if (formValidated) api.updateUserInfo({ user : this.$store.state.user });
    },
    updateMarketing : function(event) {
      api.updateMarketingPreferences({ marketingApproval : event.target.checked ? false : true });
    },
    submitPasswordForm : function() {
      let self = this;

      if (self.password.new != '' && self.password.new == self.password.confirm) {
        self.password.error = false;

        api
          .updatePassword({
            oldPassword : self.password.current,
            newPassword : self.password.new
          })
          .then(res => {
            if (res.status === 1) self.password.updated = true;
            else self.password.error = true;
          })
          .catch(error => {});
      } else self.password.error = true;
    }
  }
};
</script>